import { render } from "./BuoyComponent.vue?vue&type=template&id=16bd5878&scoped=true"
import script from "./BuoyComponent.vue?vue&type=script&lang=js"
export * from "./BuoyComponent.vue?vue&type=script&lang=js"

import "./BuoyComponent.vue?vue&type=style&index=0&id=16bd5878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bd5878"]])

export default __exports__